import React from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { MDBDataTableV5 } from 'mdbreact'
import { Link } from 'react-router-dom'
import ListFeaturedMatches from '../../Services/Queries/ListFeaturedMatches'
import AwsConfig from '../../Config/AwsConfig'

class FeaturedMatches extends React.Component {
  toastStyle = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }

  constructor(props) {
    super(props)
    this.state = {
      data: {
        columns: [
          {
            label: 'Id',
            field: 'id',
            width: 150,
          },
          {
            label: 'Match Name',
            field: 'name',
            width: 150,
          },
          {
            label: 'Match Title',
            field: 'title',
            width: 270,
          },
          {
            label: 'Match Status',
            field: 'status',
            width: 270,
          },
          {
            label: 'Start Date',
            field: 'startDate',
            width: 270,
          },
          {
            label: 'Team A',
            field: 'teamA',
            width: 200,
          },
          {
            label: 'Team B',
            field: 'teamB',
            width: 80,
          },
        ],
        rows: [],
      },
      itemToEdit: {},
      itemToDelete: {},
      createUserModalVisible: false,
      deleteModalVisible: false,
      editMode: false,
    }
  }
  getFormattedDate = (date) => {
    var dd = date.getDate()
    var mm = date.getMonth() + 1

    var yyyy = date.getFullYear()
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    var formattedDate = dd + '/' + mm + '/' + yyyy
    var hh = date.getHours()
    var m = date.getMinutes()
    var d = 'AM'
    var h = hh
    if (h >= 12) {
      h = hh - 12
      d = 'PM'
    }
    if (h == 0) {
      h = 12
    }
    m = m < 10 ? '0' + m : m
    const formattedTime = h + ':' + m + ' ' + d
    return formattedDate + ' ' + formattedTime
  }
  componentDidMount = async () => {
    const response = await ListFeaturedMatches()
    if (response.matchesInfo) {
      const parsedData = JSON.parse(response.matchesInfo)
      console.log(parsedData, 'parsedData=============')
      let matchesList = []
      const ListItems = parsedData && parsedData.length > 0 ? parsedData : []
      ListItems.map((item, index) => {
        item.id = parseInt(index) + 1
        item.teamA = item.teams.a.name
        item.teamB = item.teams.b.name
        item.startDate = this.getFormattedDate(new Date(item.start_at * 1000))
        matchesList.unshift(item)
      })
      console.log(matchesList, 'matchesList')
      const newObj = { ...this.state.data, rows: matchesList }
      this.setState({ data: newObj })
    }

    // if (response.status === 200) {
  }

  render() {
    const { createUserModalVisible } = this.state
    return (
      <div className=''>
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <section>
          {this.state.data.rows.length > 0 ? (
            <div className='card  '>
              <MDBDataTableV5
                searchTop
                searchBottom={false}
                hover
                entriesOptions={[10, 15, 20, 25, 50, 75, 100]}
                entries={10}
                pagesAmount={4}
                data={this.state.data}
                // checkbox

                // getValueCheckBox={(e) => {
                //   showLogs2(e);
                // }}
                // getValueAllCheckBoxes={(e) => {
                //   showLogs2(e);
                // }}
                // multipleCheckboxes
              />
            </div>
          ) : null}
        </section>
      </div>
    )
  }
}

export default FeaturedMatches
